var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex flex-col mb-4 select-none"},[_c('div',{staticClass:"font-serif text-3xl font-bold"},[_vm._t("title")],2),_c('div',{staticClass:"mt-4 text-lg font-sans"},[_vm._t("subtitle")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }